var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"container-with-sidebar container-with-sidebar-admin",attrs:{"fluid":""}},[_c('admin-sidebar',{attrs:{"collapsed":false}}),_c('router-view',{key:_vm.$route.path})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }